import {FC} from "react";
import {Broadcast, useApiCall} from "../../../lib/src/api";
import {useToasts} from "../../../lib/src/toasts/toasts";
import {config} from "../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const UnpublishBroadcastModal: FC<{ broadcast: Broadcast, onFinished: () => void }> = (props) => {
  const { broadcasts } = useApiCall(config)
  const {showToast} = useToasts()

  const submit = async () => {
    await broadcasts.update(props.broadcast.id, {
      status: "draft",
    }).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het intrekken.')
    })
    props.onFinished()
  }

  return <div>
    <div>Weet je zeker dat je de volgende publicatie wilt intrekken?</div>
    <div className={'font-semibold'}>&middot; {props.broadcast.subject}</div>
    <ModalFooter text={'Intrekken'} onSubmit={async () => {
      await submit()
      close()
    }} />
  </div>
}